/**
 * COGS Settings tab — how saved materials totals and missing-cost notes work.
 */
export function ManufacturingPricingMaterialsLegend() {
  return (
    <div className="space-y-3 text-sm text-gray-700 dark:text-zinc-300">
      <div>
        <div className="font-semibold text-gray-900 dark:text-zinc-100">Saved materials total</div>
        <p className="mt-1 text-xs leading-relaxed text-gray-600 dark:text-zinc-400">
          The materials dollar amount is the sum of bill lines that already have a unit cost. The
          first time you open a page, those products are calculated and saved. Later visits read the
          saved totals. Hover the clock during that work to save later pages ahead of time.
        </p>
      </div>
      <div>
        <div className="font-semibold text-gray-900 dark:text-zinc-100">Missing costs</div>
        <p className="mt-1 text-xs leading-relaxed text-gray-600 dark:text-zinc-400">
          <span className="font-medium text-rose-800 dark:text-rose-300">N missing</span> means that
          many materials have no unit cost, so they are left out of the dollar amount. Open the note
          to see the part code, name, and quantity.{" "}
          <span className="font-medium">Refresh materials (page)</span> recalculates the products
          on the page. <span className="font-medium">Also refresh</span> continues that same
          recalculation through later pages, or through every page already loaded.
        </p>
      </div>
      <div>
        <div className="font-semibold text-gray-900 dark:text-zinc-100">Labor</div>
        <p className="mt-1 text-xs leading-relaxed text-gray-600 dark:text-zinc-400">
          Labor is the sum of active company rates matched to that product. Each and as-ordered
          rates count once. Size rates use the width and length in the SKU. A rate that is missing
          Pays by, or a size, shows as incomplete and is left out of the total. Products with no
          matched rate keep a typed labor amount.
        </p>
      </div>
      <div>
        <div className="font-semibold text-gray-900 dark:text-zinc-100">Page size</div>
        <p className="mt-1 text-xs leading-relaxed text-gray-600 dark:text-zinc-400">
          25 products per page. You can show 10, 50, or 100. Group, style, size, and page
          changes use the catalog already loaded in this browser. Refresh loads it again from the
          server. While a page is calculating, minimize
          the note to a clock beside Refresh materials. Hover that clock to keep filling later pages
          in the background.
        </p>
      </div>
    </div>
  );
}
